import client from './api-client';

export const getConfiguracionForm25 = async(query) => {
    try {
        
        const response = await client.getSelect(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form25: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosImplicado = async(query) => {
    try {
        
        const response = await client.getSelect(`caso/implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosImplicado: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
